export default __webpack_public_path__ + "static/media/P30006.d72dec01.png";